import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { auth, firestore } from "../../firebase";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import {
  IconButton,
  Box,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    margin: 10,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 9,
    marginTop: 9,
  },
  root1: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.primary,
  },
  paper1: {
    fontSize: 14,
    textAlign: 'center',
    color: theme.palette.text.primary,
    backgroundColor: 'lightgrey'
  },
}));

export default function Employee(props) {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;
  const history = useHistory();
  const { managerId } = useParams();
  const [addPoints, setAddpoints] = useState([]);
  const [items, setItems] = useState([]);
  const [refItems, setRefItems] = useState([]);
  const [doc, setDoc] = useState([]);
  const [isAdded, setIsAdded] = useState(false);

  const [mobileNumber, setMobileNumber] = useState('');

  const [redeemPoints, setRedeemPoints] = useState(0);
  useEffect(() => {
    firestore.collection('Employees').where('managerId', '==', managerId).get().then(querySnapshot => {
      const listItems = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setItems(listItems);
      let arr = JSON.parse(JSON.stringify(listItems));
      setRefItems(arr);
    });

    firestore.collection('Managers').doc(managerId).get().then(querySnapshot => {
      const listItems = [{
        id: doc.id,
        ...querySnapshot.data(),
      }];
      setDoc(listItems);
    });
  }, [managerId]);

  function changePoints(id, value, items) {
    if (!(Number.isInteger(parseInt(value)))) {
      return;
    }
    var newItems = [...items];
    for (var i in newItems) {
      if (newItems[i].id === id) {
        newItems[i].rewards = parseInt(newItems[i].rewards) + parseInt(value);
        setItems(newItems);
        break; //Stop this loop, we found it!
      }
    }
  }

  const onSubmitPoints = (id) => {
    let updatedManagerItem = doc[0];
     const pointedAdded = getValue(id);
     if (pointedAdded  <= 0) {
       props.openSnackbar("Please enter positive points to add");
       return;
     }
 
     const pointsRequire = parseInt(updatedManagerItem.rewards) - parseInt(pointedAdded);
     if (parseInt(pointsRequire) < 0) {
       props.openSnackbar("Your point balance is low, you can assign only " + (parseInt(updatedManagerItem.rewards)) + " points.");
       return;
     }

    const date = new Date();
    const currentUser = auth.currentUser;
    var updatedItem = items.find(x => x.id === id);
    updatedManagerItem.rewards = parseInt(updatedManagerItem.rewards) - parseInt(pointedAdded);

    firestore.collection('Employees')
      .doc(id).update({...updatedItem, rewards: parseInt(updatedItem.rewards) + parseInt(pointedAdded)}).then(() => {
        firestore.collection('Managers')
          .doc(managerId).update(updatedManagerItem).then(() => {
            firestore.collection('Transactions').add({
              workerId: id,
              managerId: managerId,
              transactionDoneBy: currentUser.email,
              transactionDate: date.toString(),
              createdDate: date.toString(),
              previousPoints: parseInt(updatedItem.rewards),
              pointsAdded: pointedAdded,
              balance: parseInt(updatedItem.rewards) + parseInt(pointedAdded),
              createdByUserId: currentUser.uid,
              timestamp: new Date(),
            })
              .then(ref => {
                props.openSnackbar("Transaction Successful.");
                changePoints(id, getValue(id), items);
                setAddpoints([...addPoints.filter(x => x.id !== id)]);
              });
          });
      });
  }

  const onRedeemPoints = (id) => {
    const date = new Date();
    const currentUser = auth.currentUser;
    var updatedItem = items.find(x => x.id === id);
    const remaningPoints = -parseInt(redeemPoints);

    if (!(redeemPoints <= updatedItem.rewards)) {
      props.openSnackbar("You can redeem only " + updatedItem.rewards);
      return;
    }

    if (redeemPoints <= 0) {
      props.openSnackbar("Please enter positive points to redeem");
      return;
    }
  
    firestore.collection('Employees')
      .doc(id).update({...updatedItem, rewards: parseInt(updatedItem.rewards) - parseInt(redeemPoints)}).then(() => {
        firestore.collection('Transactions').add({
          workerId: id,
          managerId: managerId,
          transactionDoneBy: currentUser.email,
          transactionDate: date.toString(),
          createdDate: date.toString(),
          previousPoints: updatedItem.rewards,
          pointsAdded: "-" + redeemPoints + "(Redeem)",
          balance: parseInt(updatedItem.rewards) - parseInt(redeemPoints),
          createdByUserId: currentUser.uid,
          timestamp: new Date(),
        })
          .then(ref => {
            props.openSnackbar("Transaction Successful.");
            changePoints(id, remaningPoints, items);
            setRedeemPoints(0);
          });
      });
  }

  const getValue = (id) => {
    if (addPoints && addPoints.length > 0) {
      var result = addPoints.find(x => x.id === id);
      return result && result.rewards;
    }
    return 0;
  }

  const onDeleteWorker = (id) => {
    if (window.confirm("Do you want to delete it?")) {
      firestore.collection('Employees')
        .doc(id)
        .delete().then(() => {
          setItems([...items.filter(x => x.id !== id)]);
          props.openSnackbar("Deleted Sucessfully");
        })
    }
    return;
  }

  return (
    <>
      <div className={classes.root1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper>
              <Box display="flex" flexGrow={1}>
                <IconButton onClick={() => { history.goBack() }} edge="end" color="inherit" aria-label="back">
                  <ArrowBackIosIcon />
                </IconButton>
                <Box flexGrow={1}>
                </Box>
                <Box flexGrow={1}>
                  <Typography className={classes.paper} variant="h6" component="h4">
                    My All Workers
                  </Typography>
                </Box>
                <Box flexGrow={1}>
                </Box>
                <IconButton edge="start" color="inherit" aria-label="back">
                  <ArrowBackIosIcon htmlColor="white" />
                </IconButton>
              </Box>
            </Paper>
            <Paper className={classes.paper1}>
              <span className={classes.paper1}>Remaning Points Balance: {doc[0]?.rewards}</span>
            </Paper>
          </Grid>
        </Grid>
      </div>
      <TextField
        id="filled-number"
        label="Search Using Mobile Number"
        type="number"
        onInput={(e) => {
          e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10);
          setMobileNumber(e.target.value);
        }}
        placeholder="9723622285"
        variant="outlined"
        fullWidth
        margin="normal"
        value={mobileNumber}
      />
      <div className={classes.root1}>
        {items.filter(x => {
          if (mobileNumber !== '') {
            return x.mobileNumber.includes(mobileNumber);
          }
          return true;
        }).map((item) => (
          <React.Fragment >
            <Card className={classes.root}>
              <CardContent>
                <Typography variant="h5" component="h4">
                  <u>{item.name}</u>
                </Typography>
                <Typography className={classes.pos} >
                  {item.mobileNumber}
                </Typography>
                <Typography variant="h5" className={classes.pos}>
                  {item.rewards} Reward Points
                </Typography>
                <Typography className={classes.pos}>
                  {item.desc}
                </Typography>
              </CardContent>
              <CardActions>
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      id={"reward point" + item.id}
                      label="Add points here"
                      type="number"
                      onInput={(e) => {
                        if (!(Number.isInteger(parseInt(e.target.value)))) {
                          return;
                        }
                        if (addPoints && addPoints.length > 0 && addPoints.find(x => x.id === item.id)) {
                          var points = [...addPoints];

                          for (var i in points) {
                            if (points[i].id === item.id) {
                              points[i].rewards = parseInt(e.target.value);
                              setAddpoints(points);
                              break; //Stop this loop, we found it!
                            }
                          }
                        } else {
                          addPoints.push({ id: item.id, rewards: parseInt(e.target.value) })
                        }
                      }}
                      placeholder="50"
                      variant="filled"
                      fullWidth
                      margin="normal"
                    />
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Button fullWidth variant="contained" className={classes.pos} color="primary" onClick={() => onSubmitPoints(item.id)} size="medium">Add Points</Button>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        id={"reedem point" + item.id}
                        label="Reedem points here"
                        type="number"
                        onInput={(e) => {
                          if (!(Number.isInteger(parseInt(e.target.value)))) {
                            return;
                          }
                          if (e.target.value < 0) {
                            return;
                          }
                          setRedeemPoints(e.target.value);
                        }}
                        placeholder="100"
                        variant="filled"
                        fullWidth
                        margin="normal"
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <Button fullWidth variant="contained" className={classes.pos} color="primary" onClick={() => onRedeemPoints(item.id)} size="medium">Redeem</Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button fullWidth variant="contained" className={classes.pos} color="primary" onClick={() => history.push(`/transactions/${item.id}`)} size="medium">Transactions</Button>
                    </Grid>
                  </Grid>
                  <Button fullWidth variant="contained" onClick={() => { onDeleteWorker(item.id) }} className={classes.pos} color="secondary" size="medium">Delete Worker</Button>
                </Grid>
              </CardActions>
            </Card>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}
